import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wide mb-3">
            用户口碑
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">
            影迷真实评价
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            听听青柠影院的观众怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-5xl mx-auto">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70"
            >
              <div className="flex items-start gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-secondary-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      (e.target as HTMLImageElement).style.display = 'none';
                    }}
                  />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900">{item.name}</h3>
                  <p className="text-xs text-foreground-400 mt-0.5">{item.date}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
              <div className="flex items-center gap-0.5 mt-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-accent-500 text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}